import React from 'react';
import { RadialBarChart, PolarAngleAxis, RadialBar } from 'recharts';

export const CircleChart = (props) => {
  const { color, target = 0, actual = 0, title1, title2, theme } = props;

  const decimalValue = parseFloat(Math.abs(actual) / target) * 100;
  const data = [{ name: 'actual', value: decimalValue }];
  const circleSize = 250;
  const formattedActual = `${actual < 0 ? '-' : ''}$${Math.abs(actual)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  const actualColor = actual < 0 ? '#ea857d' : color;
  const textColour = theme === 'light' ? '#475867' : '#E6E9ED';
  const dateTextColour = theme === 'light' ? '#1B2025' : '#E6E9ED';
  const barChartBackgroundColour = theme === 'light' ? '#eee' : '#3a3a3a';

  const renderTarget = () => {
    const formattedTarget = `$${target.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

    return (
      <text
        x={circleSize / 2}
        y={circleSize * 0.695}
        textAnchor="middle"
        dominantBaseline="middle"
        className="progress-label"
        style={{
          fontSize: 14,
          fontFamily: 'Roboto, sans-serif',
          lineHeight: 70,
          fill: textColour,
          textAlign: 'center',
        }}
      >
        {formattedTarget}
      </text>
    );
  };

  return (
    <RadialBarChart
      width={circleSize}
      height={circleSize}
      cx={circleSize / 2}
      cy={circleSize / 2}
      innerRadius={96}
      outerRadius={129}
      barSize={16}
      data={data}
      startAngle={90}
      endAngle={-270}
    >
      <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
      <RadialBar
        background={{ fill: barChartBackgroundColour }}
        clockWise
        dataKey="value"
        cornerRadius={circleSize / 2}
        fill={actualColor}
      />
      <text
        x={circleSize / 2}
        y={circleSize * 0.33}
        textAnchor="middle"
        dominantBaseline="middle"
        className="progress-label"
        style={{
          fontSize: 15,
          lineHeight: 50,
          fontFamily: 'Roboto, sans-serif',
          fill: dateTextColour,
          textAlign: 'center',
        }}
      >
        {title1}
      </text>
      <text
        x={circleSize / 2}
        y={circleSize * 0.485}
        textAnchor="middle"
        dominantBaseline="middle"
        className="progress-label"
        style={{
          fontSize: 30,
          fontFamily: 'Roboto, sans-serif',
          lineHeight: 70,
          fill: actualColor,
          textAlign: 'center',
          fontWeight: '500',
        }}
      >
        {formattedActual}
      </text>
      <text
        x={circleSize / 2}
        y={circleSize * 0.62}
        textAnchor="middle"
        dominantBaseline="middle"
        className="progress-label"
        style={{
          fontSize: 14,
          fontFamily: 'Roboto, sans-serif',
          lineHeight: 70,
          fill: textColour,
          textAlign: 'center',
        }}
      >
        {title2}
      </text>
      {renderTarget()}
    </RadialBarChart>
  );
};
